<template>
  <div id="live-session-add-or-update-dialog" class="custom-modal">
    <div class="modal-body">

      <div class="row">
                    <div class="col-md-3">
                      <label for>
                        <p style="margin:0px;">
                          <b>{{ this.$t("event.components.eventInfo.about.cover.title") }}</b>
                        </p>
                        <p style="margin:0px; display: flex; flex-direction:row;">
                          {{ this.$t("event.components.eventInfo.about.cover.description") }}
                          <a v-if="form.image != null" href="javascript:;" style="color: red; margin-left:10px;" @click="form.image = null">{{ this.$t("event.components.eventInfo.about.cover.cancel") }}</a>
                        </p>
                      </label>
                      <el-upload
                        :onProgress="logoProgress"
                        class="avatar-uploader"
                        :action="axios.defaults.baseURL + 'event/uploadImage?uploadType=liveEvent&language='+$i18n.locale"
                        :headers="{
                          Authorization: axios.defaults.headers['Authorization'],
                        }"
                        :show-file-list="false"
                        :on-success="logoSuccess"
                      >
                        <img v-if="form.image" :src="form.image" style="height: 200px" class="avatar" />
                        <i v-else class="fas fa-plus avatar-uploader-icon"></i>
                      </el-upload>
                      <span class="error">{{ $errorMessage("image", validationErrors) }}</span>
  
                      <el-progress :percentage="logoPercent" v-if="logoPercent != 0"></el-progress>
                      <div
                        v-if="$store.state.scenes.items.length == 0"
                        style="
                          width: 100%;
                          height: 200px;
                          display: flex;
                          align-items: center;
                          justify-content: center;
                          flex-direction: column;
                        "
                      >
                        <span>{{ this.$t("message.noStageDesign") }}</span>
                        <el-button type="primary" size="mini" @click="sceneModal = true">{{ $t("message.manageScenes") }}</el-button>
                      </div>
  
                      <div>
                        <el-carousel indicator-position="none" ref="carousel" :interval="5000" arrow="never" :autoplay="false" :loop="false">
                          <el-carousel-item v-for="item in $store.state.scenes.items" :key="item.id">
                            <div class="scenes" style="cursor: pointer">
                              <div class="scene-wrapper">
                                <div @click="sceneModal = true" class="scene" :style="'background-image: url(' + item.background + ');'">
                                  <div class="banner" :style="'background-image: url(' + item.top + ');'"></div>
                                  <span
                                    style="
                                      font-size: 15px;
                                      font-weight: bold;
                                      color: white;
                                      text-shadow: 0px 0px 8px rgba(0, 0, 0, 1);
                                      display: block;
                                      background-color: rgba(0, 0, 0, 0.5);
                                      width: 100%;
                                      text-align: center;
                                    "
                                    >{{ item.title }}</span
                                  >
                                  <div class="banner" :style="'background-image: url(' + item.bottom + ');'"></div>
                                </div>
                                <el-button-group
                                  :key="item.id + form.sceneID"
                                  style="
                                    width: 100%;
                                    background-color: #fff;
                                    display: flex;
                                    align-items: center;
                                    justify-content: center;
                                    padding-top: 10px;
                                  "
                                >
                                  <el-button size="mini" @click="$refs.carousel.prev()"> &lt; </el-button>
                                  <el-button size="mini" type="primary" @click="$set(form, 'sceneID', item.id)">
                                    {{ form.sceneID == item.id ? $t("event.buttons.selected") : $t("event.buttons.select_") }}
                                  </el-button>
                                  <el-button size="mini" @click="$refs.carousel.next()">></el-button>
                                </el-button-group>
                              </div>
                            </div>
                          </el-carousel-item>
                        </el-carousel>
                      </div>
                    </div>
                    <div class="col-md-9">
                      <div class="row">
                        <div class="col-md-6">
                          <label style="display: block">{{ this.$t("event.table.title") }}</label>
                          <el-input v-model="form.title"></el-input>
                          <span class="error">{{ $errorMessage("title", validationErrors) }}</span>
                        </div>
  
                        <div class="col-md-6">
                          <ActionableLabel :title="$t('event.table.checkpoint')" @refresh="$store.dispatch('getVenues')" @new="addVenueModal = true" />
                          <el-select v-model="form.venueID" clearable>
                            <el-option v-for="item in $store.state.venues.items" :key="item.id" :label="item.title" :value="item.id"></el-option>
                          </el-select>
                          <span class="error">{{ $errorMessage("venueID", validationErrors) }}</span>
                        </div>
  
                        <div class="col-md-12" style="margin-top: 15px">
                          <label style="display: block">{{ this.$t("event.tags.startEndDate") }}</label>
                          <el-date-picker 
                          :format="datePickerDisplayFormat()" 
                            v-model="selectedDates"
                            type="datetimerange"
                            value-format="yyyy-MM-ddTHH:mm:ssZ"
                            range-separator=">"
                            :start-placeholder="$t('event.textbox.datePickerStart')"
                            :end-placeholder="$t('event.textbox.datePickerEnd')"
                          ></el-date-picker>
                          <div style="display: flex; width: 100%">
                            <div style="display: flex; flex: 1">
                              <span class="error" style="text-align: center">{{ $errorMessage("startDate", validationErrors) }}</span>
                            </div>
                            <div style="display: flex; flex: 1">
                              <span class="error" style="text-align: center">{{ $errorMessage("endDate", validationErrors) }}</span>
                            </div>
                          </div>
                        </div>
  
                        <div class="col-md-12" style=" display:none; margin-top: 15px">
                          <el-alert :title="$t('event.tags.cloudArchiving')" type="info" :closable="false" :description="$t('liveSessions.cloudDesc')" show-icon>
                            <div slot="title">
                              <p style="color: rgb(3, 101, 140); font-size: 16px">
                                {{ this.$t("event.tags.cloudArchiving") }}
                              </p>
                              <el-switch
                                :disabled="form.vimeoItems.length > 0"
                                v-model="form.isRecording"
                                :active-text="form.vimeoItems.length == 0 ? $t('event.tags.active_') : $t('event.tags.archiveVimeo')"
                                :inactive-text="form.vimeoItems.length > 0 ? '' : $t('event.tags.deactive_')"
                              ></el-switch>
                            </div>
                          </el-alert>
                        </div>
  
                        <div class="col-md-12">
                          <div class="row" style="margin: 0">
                            <div class="col-md-6 pl-0" style="margin-top: 15px">
                              <el-alert :title="$t('liveSessions.liveActive')" :type="form.isLive ? 'success' : 'warning'" :closable="false" :description="$t('liveSessions.activationDesc')" :show-icon="false">
                                <div slot="title">
                                  <p
                                    style="
                                      color: rgb(3, 101, 140);
                                      font-size: 16px;
                                    "
                                  >
                                    {{ this.$t("liveSessions.liveActive") }}
                                  </p>
                                  <el-switch v-model="form.isLive" :active-text="$t('event.variables.yes')" :inactive-text="$t('event.variables.no')"></el-switch>
                                </div>
                              </el-alert>
                            </div>
  
                            <div class="col-md-6 pr-0" style="margin-top: 15px">
                              <el-alert :title="$t('event.table.status')" :type="form.isActive ? 'success' : 'error'" :closable="false" :description="$t('liveSessions.statusDesc')" :show-icon="false">
                                <div slot="title">
                                  <p
                                    style="
                                      color: rgb(3, 101, 140);
                                      font-size: 16px;
                                    "
                                  >
                                    {{ this.$t("event.table.status") }}
                                  </p>
                                  <el-switch v-model="form.isActive" :active-text="$t('event.table.active')" :inactive-text="$t('event.table.passive')"></el-switch>
                                </div>
                              </el-alert>
                            </div>
  
                            <div class="col-md-12 p-0" style="margin-top: 15px; background-color: #eef9f9" v-if="form.vimeoItems.length == 0">
                              <div style="padding: 8px 24px">
                                <p
                                  style="
                                    color: rgb(3, 101, 140);
                                    font-size: 16px;
                                    font-weight: 700;
                                    margin-bottom: 0.3em;
                                  "
                                >
                                  {{ this.$t("liveSessions.important") }}
                                </p>
                                <p
                                  style="
                                    color: rgb(3, 101, 140);
                                    font-size: 12px;
                                    margin-bottom: 0.3em;
                                    font-weight: 500;
                                  "
                                >
                                  {{ this.$t("liveSessions.importantDesc") }}
                                </p>
                                <p
                                  style="
                                    color: rgb(3, 101, 140);
                                    font-size: 12px;
                                    font-weight: 500;
                                  "
                                >
                                  {{ this.$t("liveSessions.importantDesc_") }}
                                </p>
                              </div>
                            </div>
  
                            <div class="col-md-12 p-0" style="margin-top: 15px; background-color: #eef9f9" v-if="form.vimeoItems.length == 0 && data != null && form.publishers.length == 0">
                              <div style="padding: 8px 24px">
                                <p
                                  style="
                                    color: rgb(3, 101, 140);
                                    font-size: 16px;
                                    font-weight: 700;
                                    margin-bottom: 0.3em;
                                  "
                                >
                                  {{ this.$t("liveSessions.rtmpTitle") }}
                                </p>
                                <p
                                  style="
                                    color: rgb(3, 101, 140);
                                    font-size: 12px;
                                    margin-bottom: 0.3em;
                                    font-weight: 500;
                                  "
                                >
                                  {{ this.$t("liveSessions.rtmpDesc") }}
                                </p>
                                <el-tooltip class="item" effect="dark" :content="$t('liveSessions.rtmpCopy')" placement="top">
                                <div class="rtmp-url d-flex flex-row align-items-center justify-content-between" v-clipboard:success="copySuccess" v-clipboard:copy="rtmpUrl">
                                  <p
                                    style="
                                    color: rgb(3, 101, 140);
                                    font-size: 0.8rem;
                                    margin-bottom: 0.3em;
                                    font-weight: 500;
                                  "
                                  >
                                    {{ this.rtmpUrl }}
                                  </p>
                                  <i class="el-icon-document-copy"></i>
                                </div>
                                </el-tooltip>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
  
                  <div
                    class="row"
                    v-if="form.publishers.length == 0"
                    style="
                      padding: 20px 10px;
                      background: #e6e6e6;
                      border-radius: 5px;
                      margin: 0px;
                      margin-top: 20px;
                      margin-bottom: 20px;
                    "
                  >
                    <h4 class="col-md-12 mt-2" style="display: flex; justify-content: space-between">
                      {{ this.$t("liveSessions.vimeoSesions") }}
                      <a
                        href="javascript:;"
                        class="btn btn-info"
                        @click="
                          form.vimeoItems.push({
                            title: null,
                            url: null,
                            description: null,
                          });
                          form.isRecording = false;
                        "
                        >{{ this.$t("event.components.participants.navbar.add") }}</a
                      >
                    </h4>
                    <div class="row col-md-12 mt-2 pr-0" v-for="(vimeo, vimeoIndex) in form.vimeoItems" :key="vimeoIndex">
                      <div class="col-md-2">
                        <el-input v-model="vimeo.title" :placeholder="$t('event.table.title')"></el-input>
                      </div>
                      <div class="col-md-4">
                        <el-input v-model="vimeo.url" placeholder="URL"></el-input>
                      </div>
                      <div class="col-md-5">
                        <el-input v-model="vimeo.description" :placeholder="$t('event.tags.description')"></el-input>
                      </div>
                      <div class="col-md-1 pr-0">
                        <a href="javascript:;" @click="form.vimeoItems.splice(vimeoIndex, 1)" class="btn btn-danger" style="width: 100%">{{ $t("event.table.delete") }}</a>
                      </div>
                    </div>
                  </div>
                  <div class="row" style="margin-top: 20px" v-if="form.vimeoItems.length == 0">
                    <div class="col-md-6">
                      <div>
                        <h4>
                          <ActionableLabel :title="$t('event.menu.recordSales.participants')" @refresh="$store.dispatch('getParticipants')" @new="addParticipantModal = true" />
                        </h4>
                        <el-input style="margin-bottom: 10px" v-model="$store.state.participants.filter.searchTerm" :placeholder="$t('event.textbox.searchForParticipant')"></el-input>
                        <el-select style="margin-bottom: 10px" multiple v-model="$store.state.participants.filter.tagIDs" :placeholder="$t('event.textbox.selectTag')">
                          <el-option v-for="item in $store.state.tags.items" :key="item.id" :label="item.title" :value="item.id">
                            <div
                              style="
                                display: flex;
                                flex-direction: row;
                                align-items: center;
                                justify-content: space-between;
                              "
                            >
                              <span style="float: left">{{ item.title }}</span>
                              <span
                                style="
                                  color: #8492a6;
                                  font-size: 13px;
                                  width: 15px;
                                  height: 15px;
                                  display: inline-block;
                                "
                                :style="'background-color: ' + item.color"
                              ></span>
                            </div>
                          </el-option>
                        </el-select>
                        <div v-loading="$store.state.participants.loading">
                          <div
                            v-for="item in $store.state.participants.items"
                            :key="item.id"
                            style="
                              display: flex;
                              flex-direction: row;
                              align-items: center;
                              padding: 5px 5px;
                              box-shadow: -1px 2px 6px rgba(0, 0, 0, 0.1);
                              margin-bottom: 5px;
                            "
                          >
                            <div
                              style="
                                margin-left: 10px;
                                display: flex;
                                flex-direction: column;
                                flex: 1;
                              "
                            >
                              <ParticipantMini :data="item" />
                            </div>
                            <el-button v-if="!form.publishers.some((k) => k.id == item.id)" @click="form.publishers.push(item)" type="success" icon="el-icon-arrow-right" circle></el-button>
                            <el-button
                              v-if="form.publishers.some((k) => k.id == item.id)"
                              @click="
                                form.publishers.splice(
                                  form.publishers.findIndex((k) => k.id == item.id),
                                  1
                                )
                              "
                              type="danger"
                              icon="el-icon-close"
                              circle
                            ></el-button>
                          </div>
                        </div>
                        <el-pagination
                          background
                          @size-change="handleSizeChange"
                          @current-change="handleCurrentChange"
                          :current-page.sync="$store.state.participants.filter.page"
                          :page-sizes="[20, 30, 40, 50]"
                          :page-size="$store.state.participants.filter.take"
                          layout="prev, pager, next"
                          :total="$store.state.participants.filter.total"
                        ></el-pagination>
                      </div>
                    </div>
  
                    <!-- **************************************************************** -->
                    <div class="col-md-6">
                      <h4 style="font-size: 16px;">{{ this.$t("liveSessions.electedSpeaker") }}</h4>
                      <draggable v-model="form.publishers" v-bind="dragOptions">
                        <transition-group type="transition" name="flip-list">
                          <div
                            class="list-group-item"
                            v-for="(item, index) in form.publishers"
                            :key="index + 1"
                            style="
                              display: flex;
                              flex-direction: row;
                              align-items: center;
                              padding: 5px 5px;
                              box-shadow: -1px 2px 6px rgba(0, 0, 0, 0.1);
                              margin-bottom: 5px;
                            "
                          >
                            <div
                              style="
                                margin-left: 10px;
                                display: flex;
                                flex-direction: column;
                                flex: 1;
                              "
                            >
                              <ParticipantMini :data="item" />
                              <div style="margin-top: 10px">
                                <el-switch v-model="form.publishers[index].isActive" :active-text="$t('event.table.active')" :inactive-text="$t('event.table.passive')"></el-switch>
                              </div>
                            </div>
                            <el-button v-if="!form.publishers.some((k) => k.id == item.id)" @click="form.publishers.push(item)" type="success" icon="el-icon-arrow-right" circle></el-button>
                            <el-button
                              v-if="form.publishers.some((k) => k.id == item.id)"
                              @click="
                                form.publishers.splice(
                                  form.publishers.findIndex((k) => k.id == item.id),
                                  1
                                )
                              "
                              type="danger"
                              icon="el-icon-close"
                              circle
                            ></el-button>
                          </div>
                        </transition-group>
                      </draggable>
                    </div>
                  </div>

    </div>
    <div class="modal-footer" slot="footer">
      <div class="left-buttons">
        <el-button @click="$emit('closeDialog');">{{$t('components.liveSessionAddUpdate.close')}}</el-button>
        <el-popconfirm @confirm="deleteItem" :confirmButtonText="$t('event.variables.yes')" :cancelButtonText="$t('event.buttons.cancel')" icon="el-icon-info" iconColor="red" :title="$t('event.textbox.toDelete')">
          <el-button slot="reference" type="danger" icon="fas fa-trash" v-if="form.id != null"> {{$t('components.liveSessionAddUpdate.delete')}}</el-button>
        </el-popconfirm>
      </div>
      <div class="right-buttons">
        <el-button type="primary" @click="save">{{$t('components.liveSessionAddUpdate.save')}}</el-button>
      </div>
    </div>

    <el-dialog :close-on-click-modal="false" :visible.sync="addParticipantModal" :title="$t('event.tags.addParticipant')" class="large" center modal-append-to-body destroy-on-close>
      <ParticipantAddOrUpdate @closeDialog="addParticipantModal = false" @itemAdded="itemAdded" :data="null" :key="addParticipantModal" />
    </el-dialog>
    <el-dialog :close-on-click-modal="false" :visible.sync="addVenueModal" :title="$t('event.tags.addCheckpoint')" class="large" center modal-append-to-body destroy-on-close>
      <VenueAddUpdate @closeDialog="addVenueModal = false" @itemAdded="itemAddedVenue" :data="null" />
    </el-dialog>
    <el-dialog :close-on-click-modal="false" :visible.sync="sceneModal" :title="$t('message.scenes')" class="large" center modal-append-to-body destroy-on-close>
      <Scenes @closeDialog="sceneModal = false;"/>
    </el-dialog>

  </div>
</template>

<script>
import axios from "axios";
import ItemInfo from "./ItemInfo";
import draggable from "vuedraggable";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import DayAddUpdate from "./DayAddUpdate";
import SaloonAddUpdate from "./SaloonAddUpdate";
import SubEventAddUpdate from "./SubEventAddUpdate";
import VenueAddUpdate from "./VenueAddUpdate";
import ParticipantAddOrUpdate from "./ParticipantAddOrUpdate";
import Scenes from "./Scenes";
import $ from "jquery";
import { quillEditor } from "vue-quill-editor";
/* import moment from 'moment' */

export default {
  components: {
    ItemInfo,
    draggable,
    quillEditor,
    DayAddUpdate,
    SaloonAddUpdate,
    SubEventAddUpdate,
    VenueAddUpdate,
    Scenes,
    ParticipantAddOrUpdate,
  },
  name: "LiveSessionAddUpdate",
  props: ["data"],
  data() {
    return {
      form: {
        id: null,
        title: null,
        image: null,
        startDate: null,
        endDate: null,
        youtubeURL: null,
        rmtpUrl: null,
        orderNO: 0,
        isLive: true,
        isActive: true,
        publishers: [],
        venueID: null,
        vimeoItems: [],
        backgrounBanner: null,
        topBanner: null,
        bottomBanner: null,
        isRecording: true,
      },
      addNewSubEvent: false,
      logoPercent: 0,
      axios,
      validationErrors: [],
      showInfo: false,
      addGroupModal: false,
      addNewDay: false,
      addNewSaloon: false,
      addVenue: false,
      selectedDates: [],
      sceneModal: false,
      addParticipantModal: false,
      addVenueModal: false,
      rtmpUrl: null,
    };
  },
  async beforeMount() {
    if (this.data != null) {
      var res = await axios.post("livestream/gethash", { id: this.data.id });
      if (res.data.alert.hasError == false) {
        this.rtmpUrl = `rtmp://rtmp.holacon.com/live/${this.data.id}?sign=${res.data.data}`;
      } else {
        this.$message.error(res.data.alert.message);
      }
    }
  },
  mounted() {
    this.$store.dispatch("getParticipants");
    this.$store.dispatch("getVenues");
    this.$store.dispatch("listScenes");

    this.selectedDates = this.selectedDates((x) => new Date(x));
  },
  methods: {
    async itemAddedVenue(item) {
      await this.$store.dispatch("getVenues");
      this.form.venueID = item;
    },
    logoProgress(event) {
      this.logoPercent = event.percent;
    },
    logoSuccess(response) {
      this.logoPercent = 0;
      if (response.alert.hasError) {
        this.$message.error(response.alert.message);
      } else {
        this.$message.success(response.alert.message);
        this.form.image = response.data.item.url;
      }
    },
    async itemAdded(item) {
      await this.$store.dispatch("getParticipants");
      //this.form.dayID = item;
    },
    handleSizeChange(take) {
      this.$store.commit("setParticipantTake", take);
    },
    handleCurrentChange(page) {
      $("html, body").animate({ scrollTop: 0 }, 350);
      this.$store.commit("setParticipantPage", page);
    },
    deleteItem() {
      var index = this.$store.state.livesessions.items.findIndex((k) => k.id == this.form.id);
      if (index != -1) {
        this.$emit("deleteMe", index);
        this.$emit("closeMe");
      }
    },
    copySuccess() {
      this.$message.success(this.$t("liveSessions.rtmpMessage"));
    },
    save() {
      this.validationErrors = [];

      var participants = [];

      this.form.publishers.map((x) => {
        participants.push({
          participantID: x.id,
          type: 2,
          isActive: x.isActive,
        });
      });

      axios
        .post("livestream/addorupdate", {
          ...this.form,
          publishers: participants,
          startDate: this.selectedDates[0],
          endDate: this.selectedDates[1],
          isRecording: true,
        })
        .then((res) => {
          this.validationErrors = res.data.validationErrors;
          if (res.data.alert.hasError) {
            this.$message.error(res.data.alert.message);
          } else {
            this.$message.success(res.data.alert.message);
            if (this.form.id == null) {
              this.$emit("itemAdded");
              this.form = {
                id: null,
                title: null,
                image: null,
                startDate: null,
                endDate: null,
                youtubeURL: null,
                rmtpUrl: null,
                orderNO: 0,
                isLive: true,
                isActive: true,
                publishers: [],
                vimeoItems: [],
                venueID: null,
                backgrounBanner: null,
                topBanner: null,
                bottomBanner: null,
                isRecording: true,
              };
            } else {
              this.$emit("itemUpdated", JSON.parse(JSON.stringify(this.form)));
              if (this.showInfo) {
                this.showInfo = false;
                setTimeout(() => {
                  this.showInfo = true;
                }, 350);
              }
            }
          }
        });
    },
  },
  watch: {
    data: function(newVal) {
      this.showInfo = false;
      if (newVal != undefined && newVal != null) {
        this.form = {
          ...this.data,
        };
        this.selectedDates = [this.data.startDate, this.data.endDate];
        this.validationErrors = [];
      } else {
        this.form = {
          id: null,
          title: null,
          image: null,
          startDate: null,
          endDate: null,
          youtubeURL: null,
          rmtpUrl: null,
          orderNO: 0,
          isLive: true,
          isActive: true,
          publishers: [],
          vimeoItems: [],
          venueID: null,
          backgrounBanner: null,
          topBanner: null,
          bottomBanner: null,
          isRecording: true,
        };
        this.selectedDates = [this.$moment(this.$store.state.event.event.startDate).format("YYYY-MM-DDTHH:mm:ss") + "Z", this.$moment(this.$store.state.event.event.startDate).format("YYYY-MM-DDTHH:mm:ss") + "Z"];
      }
    },
    "$store.state.participants.filter.searchTerm": function() {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.$store.dispatch("getParticipants");
      }, 500);
    },
    "$store.state.participants.filter.tagIDs": function() {
      this.$store.dispatch("getParticipants");
    },
  },
  created() {
    if (this.data != undefined && this.data != null) {
      this.selectedDates = [this.data.startDate, this.data.endDate];
      this.form = this.data;
    } else {
      this.selectedDates[0] = this.$moment(this.$store.state.event.event.startDate).format("YYYY-MM-DDTHH:mm:ss") + "Z";
      this.selectedDates[1] = this.$moment(this.$store.state.event.event.startDate).format("YYYY-MM-DDTHH:mm:ss") + "Z";
    }

    this.$store.commit("setParticipantTake", 5);
  },
  computed: {
    getVenues() {
      if (this.form.subEventID != null && this.form.subEventID != "") {
        return this.$store.state.venues.items.filter((k) => k.type == 3);
      }
      return this.$store.state.venues.items;
    },
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost",
      };
    },
    isSubEventDisabled() {
      if (this.form.venueID == null || this.form.venueID == "") return false;
      var venue = this.$store.state.venues.items.find((k) => k.id == this.form.venueID);
      return venue.type != 3;
    },
  },
};
</script>

<style>
.flip-list-move {
  transition: transform 0.5s;
}
.list-group {
  min-height: 20px;
}
.list-group-item {
  cursor: move;
}
.list-group-item i {
  cursor: pointer;
}

#live-session-add-or-update-dialog .el-carousel__container {
  height: 200px;
}
</style>
<style scoped>
.scenes {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
}

.scenes .scene {
  background-size: cover;
  display: flex;

  align-items: center;
  justify-content: space-between;
  flex-direction: column;
  overflow: hidden;
  height: 150px;
}

.scene-wrapper {
  width: 100%;
  background-color: grey;
  margin: unset;
}

.scene .background {
  display: flex;
  flex: 1;
  background: green;
  height: 100%;
  width: 100%;
}

.scene .banner {
  height: 40px;
  width: 100%;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}

.rtmp-url {
  color: rgb(3, 101, 140);
  font-size: 12px;
  margin-bottom: 0.3em;
  font-weight: 500;
  background: #fff;
  border-radius: 10px;
  padding: 20px 20px;
  cursor:pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/LiveSessionAddUpdate.vue